// extracted by mini-css-extract-plugin
export default {"ppm_navbar":"Navbar_ppm_navbar__W+vaD","toggleBtn":"Navbar_toggleBtn__KIyKx","ppm_logo":"Navbar_ppm_logo__NB+rx"};